import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=4c07a453"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"
import style0 from "./Stock.vue?vue&type=style&index=0&id=4c07a453&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c07a453')) {
      api.createRecord('4c07a453', component.options)
    } else {
      api.reload('4c07a453', component.options)
    }
    module.hot.accept("./Stock.vue?vue&type=template&id=4c07a453", function () {
      api.rerender('4c07a453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/Stock.vue"
export default component.exports